import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from './context/AuthContext'; 
import Header from "./components/Header";
import Footer from "./components/Footer"; 
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes/AppRoutes' ;

function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Router>
        <AuthProvider>
          <Header />
          <AppRoutes />
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
          <Footer />
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
